import meta from '../helper/meta';
import Breakpoint from "@core/scripts/helper/breakpoint.js";

const InputMethod = {
    Type: {
        MOUSE: {css: "is-mouse", event: "mouse"},
        TOUCH: {css: "is-touch", event: "touch"}
    },
    translateToInputMethodType: (type) => {
        return type === InputMethod.Type.TOUCH.event ? InputMethod.Type.TOUCH : InputMethod.Type.MOUSE;
    }
};

let currentInputMethodType = document.documentElement.classList.contains(InputMethod.Type.TOUCH.css) ?
    InputMethod.Type.TOUCH : InputMethod.Type.MOUSE;

function setCurrentInputMethodType(newInputMethodType) {
    currentInputMethodType = newInputMethodType;
}

function getCurrentInputMethodType() {
    return currentInputMethodType;
}

function isTouch() {
    return currentInputMethodType === InputMethod.Type.TOUCH;
}

function isMouse() {
    return currentInputMethodType === InputMethod.Type.MOUSE;
}

function isIpad() {
    return navigator.userAgent.match(/iPad/i) !== null;
}

function isApp() {
    return meta.value('isApp');
}

function isTablet() {
    return meta.value('isTablet');
}

function isIOS() {
    return meta.value('isIOS');
}

function isLandscapeMode() {
    return Breakpoint.keyIsIn(['small', 'medium']) && (screen?.orientation?.angle === 90 || window.orientation === 90);
}

export default {
    InputMethod,
    setCurrentInputMethodType,
    getCurrentInputMethodType,
    isTablet,
    isTouch,
    isMouse,
    isIpad,
    isApp,
    isLandscapeMode,
    isIOS
};
